import {Component, Input, ViewChild} from '@angular/core';
import {
  PolicyContractVersionCriteriaDto,
  PolicyContractVersionSimpleDto,
} from '../../../../../bonding_shared/model/dtos';
import {RouterService, SearchDataProvider} from '../../../../../bonding_shared/services';
import {ATableComponent} from '../../../../../bonding_shared/components/aku-table/a-table.component';

@Component({
  selector: 'company-surety-exposure',
  templateUrl: './company-surety-exposure.component.pug',
})
export class CompanySuretyExposureComponent {
  @ViewChild(ATableComponent, {static: true}) policyTable: ATableComponent<PolicyContractVersionSimpleDto>;

  @Input() set dataProvider(dp: SearchDataProvider<PolicyContractVersionCriteriaDto, PolicyContractVersionSimpleDto>) {
    this.policyTable.dataProvider = dp;
    this.policyTable.pagination = true;
    this.policyTable.search();
  }

  constructor(public router: RouterService) {}
}
